define([
	"dojo/_base/declare",
	"csi",
	"csi/heading/AttributeController",
	"csi/xml"
], function(declare,csi,AttributeController,xml) {

	return declare(AttributeController, {
		preProcess: function() {
			// summary: reset new value
			this.newValue = csi.EMPTY_URL;
			this.inherited(arguments);
		},

		_toWriterValue: function(/*String*/id, /*String*/type) {
			// summary: set reference to file
			return this.inherited(arguments)
				.addAttribute(xml.idGetFile(id), xml.ATTR_STRING, "", xml.ATTR_FLAG_NOEDIT);
		}
	});
});